import { render } from "./CreateOperation.vue?vue&type=template&id=1b24e3ea&scoped=true"
import script from "./CreateOperation.vue?vue&type=script&lang=js"
export * from "./CreateOperation.vue?vue&type=script&lang=js"

import "./CreateOperation.vue?vue&type=style&index=0&id=1b24e3ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b24e3ea"]])

export default __exports__